module.exports = __webpack_public_path__ + "static/media/mask-group-3.424f2f41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mask-group-3.png
// module id = 1294
// module chunks = 1